<template>
    <div>
        <Breadcrumbs
      page_title="companypoliciesandregulations"
      :items="breadcrumbs"
    />
          <v-card class="mx-3 my-5" style="border-radius: 16px">
           <v-row>
        <v-col cols="6" lg="6" md="6" sm="6">
              <p class="ml-5">{{ (CompanyItems.companyName) }}</p>
               <p class="ml-5">{{ $t("date") }} : {{ currentDate  }}</p>
        </v-col>
        <v-col cols="6"  class="d-flex flex-column align-end ">
           
            <p class="mb-1 mr-5">{{ $t("active") + ' / ' + $t("inactive") }}</p>

              <div class="onoffswitch mt-2 mr-15">
                <input
                  type="checkbox"
                  name="onoffswitch"
                  class="onoffswitch-checkbox"
                  id="myonoffswitch1"
                  v-model="CompanyItems.ragulationFlag"
                />
                <label class="onoffswitch-label" for="myonoffswitch1">
                  <div class="onoffswitch-inner"></div>
                  <div class="onoffswitch-switch"></div>
                </label>
              </div>
            </v-col>
           </v-row>
          <!-- <v-row
            v-for="(section, index) in sections"
            :key="index"
            class="mb-1"
            >
            <v-col cols="12" class="ml-5">
                <label class="font-weight-bold mb-1">{{ index + 1 }}. {{ section.title }}</label>
                <v-textarea
             v-model="CompanyItems.ragulationText"
                solo
                flat
                rows="2"
                class="no-border-textarea"
                />
            </v-col>
            </v-row> -->
            <v-row class="ml-5 mr-6">
                    <v-textarea
                     v-model="CompanyItems.ragulationText"
                      auto-grow
                      outlined
                   style="border-radius: 16px;"
                      rows="1"
                      hide-details
                      class="custom-textarea"
                    />
                </v-row>
         <v-card-text class="pa-0">
          <div class="mt-5 pb-10 mr-9">
            <v-row class="d-flex justify-end mt-10">
              <v-btn
                  class="text-capitalize btnfont-style mr-2"
                  text
                  outlined
                  @click="cancelAdd()"
              >
                  {{ $t("cancel") }}
              </v-btn>
              <v-btn
                  class="text-capitalize btnfont-style"
                  color="secondary"
                  @click="AddCompanyRegulation()"
              >
                  {{ $t("submit") }}
              </v-btn>
            </v-row>
          </div>
        </v-card-text>
              
          </v-card>
          <SuccessDialog
      :show="successDialog"
      :title="$t('success')"
      :text="$t('updatcompanyregulation')"
      @close="Close()"
    />
          <v-dialog v-model="loading" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#FAA91B"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
export default{
    data() {
      const now = new Date();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const yyyy = now.getFullYear();
    return {
       currentDate: `${mm}-${dd}-${yyyy}`,
           welcome: {
      welcomeTH: null,
      welcomeEN: null,
      welcomeActive: false,
    },
     successDialog: false,
    status:true,
    content: "",
    loading: false,
 breadcrumbs: [
      {
        sidebar_tilte: "setting",
      },
      {
        text: "companypoliciesandregulations",
      },
    ],
    CompanyItems: {
      companyName: '',
      ragulationFlag: false,
      ragulationText: '', 
    },
    sections: [
      { title: "Introduction", content: "" },
      { title: "Code of Conduct", content: "" },
      { title: "Equal Employment Opportunity", content: "" },
      { title: "Use of Company Resources", content: "" },
      { title: "Policy Updates", content: "" }
    ],
    };
        },
        mounted(){
this.GetCompanyRegulation();
        },
        computed: {
    dialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      },
    },
},
        methods:{
     async GetCompanyRegulation() {

  this.loading = true;

  let companyID = localStorage.getItem("companyID");

  await axios
    .get(`${this.web_url}Company/GetCompanyRagulation`, {
      params: {
        id: companyID
      }
    })
    .then((response) => {
      if (response.data.status === 0) {
        this.CompanyItems = response.data.data;
      }

    })

    .catch((err) => {
      this.loading = false;
      throw err;
    });

  this.loading = false;
},
   async AddCompanyRegulation() {
  const request = {
    companyID: localStorage.getItem("companyID"),
    ragulationFlag: this.CompanyItems.ragulationFlag,
    ragulationText: this.CompanyItems.ragulationText,
  };



  try {
    const response = await this.$axios.post(
      `${this.web_url}Company/UpdateCompanyRagulation`,
      request
    );

    if (response.data.status == 0) {
      this.dialog = true;
      this.successDialog = true;
      this.GetCompanyRegulation();

    }
  } catch (err) {
    this.loading = false;
    throw err;
  }
},

    Close() {
    
      this.successDialog = false;
      
    },
      cancelAdd(){

      },
      submit(){

      },
        },
};

</script>
<style scoped>
.custom-textarea ::v-deep textarea {
  margin-top: 3%;           
  padding-bottom: 2%;
  padding-left: 5px;
}

.custom-textarea textarea {
  font-size: 14px;                  /* Clean readable text */
  line-height: 3.5;
  padding-bottom: 12px;
}

.btnfont-style {
  font-size: 16px;
  border-radius: 8px;
}
.noti-icon .v-icon {
  color: #424242 !important;
}
.title_style {
  color: #000000;
  font-size: 22px;
}
.onoffswitch {
  position: relative;
  width: 73px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border-radius: 20px;
}

.onoffswitch-inner {
  width: 200%;
  margin-left: -100%;
  -moz-transition: margin 0.3s ease-in 0s;
  -webkit-transition: margin 0.3s ease-in 0s;
  -o-transition: margin 0.3s ease-in 0s;
  transition: margin 0.3s ease-in 0s;
}

.onoffswitch-inner:before,
.onoffswitch-inner:after {
  float: left;
  width: 50%;
  height: 28px;
  padding: 0;
  line-height: 30px;
  font-size: 14px;
  color: white;
  font-family: Trebuchet, Arial, sans-serif;
  font-weight: bold;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.onoffswitch-inner:before {
  content: "ON";
  padding-left: 11px;
  background-color: #6fdc42;
  color: #ffffff;
}

.onoffswitch-inner:after {
  content: "OFF";
  padding-right: 11px;
  color: #ffffff;
  background-color: #707070;
  opacity: 1;
  text-align: right;
}

.onoffswitch-switch {
  width: 26px;
  height: 26px;
  margin: 1px;
  background: #ffffff;
  border-radius: 20px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 44px;
  -moz-transition: all 0.3s ease-in 0s;
  -webkit-transition: all 0.3s ease-in 0s;
  -o-transition: all 0.3s ease-in 0s;
  transition: all 0.3s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0px;
}
</style>